import { Section } from "../Section";
import { SectionHeader } from "../SectionHeader";
import { ErrorRow } from "../ErrorRow";

type InsuranceErrorFallbackProps = {
  resetErrorBoundary: () => void;
};

export const InsuranceErrorFallback = ({
  resetErrorBoundary,
}: InsuranceErrorFallbackProps) => {
  return (
    <Section ariaLabel="Insurance">
      <SectionHeader heading={"Insurance"} />
      <dl className="grid grid-wrap collapsed-gutters login-data-table_row">
        <ErrorRow resetErrorBoundary={resetErrorBoundary} />
      </dl>
    </Section>
  );
};
